import Cookies from 'js-cookie'

const CoreUserIdKey = 'Core-User-Id'

export function getCoreUserId() {
  return Cookies.get(CoreUserIdKey)
}

export function setCoreUserId(userId) {
  return Cookies.set(CoreUserIdKey, userId)
}

export function removeCoreUserId() {
  return Cookies.remove(CoreUserIdKey)
}
